import { Component, Inject } from '@angular/core';
import { MatDialogContent, MatDialogActions, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SicotService } from '../sicot.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-struttura-dettaglio-dialog',
  imports: [CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule, MatProgressSpinner],
  templateUrl: './struttura-dettaglio-dialog.component.html',
  styleUrl: './struttura-dettaglio-dialog.component.css'
})
export class StrutturaDettaglioDialogComponent {

  struttura:any;
  loading = true;
  error = false;

  constructor(
    private siCotService: SicotService,
    public dialogRef: MatDialogRef<StrutturaDettaglioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Qui iniettiamo l'oggetto struttura
  ) {
    // Log di debug per verificare che i dati arrivino correttamente
    console.log('Dati struttura ricevuti:', this.data);
  }

  ngOnInit(): void {
    if (this.data && this.data.id) {
      this.siCotService.getStruttura(this.data.id).subscribe({
        next: (res) => {
          this.struttura = res;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.error = true;
        }
      });
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
